import { Component, OnInit } from '@angular/core';
import {ComGoalEmployeeJobModel} from '../../../../app/model/com-goal-employee-job.model';
import {CatEmployeeJobModel} from '../../../../app/model/cat-employee-job.model';
import {CatEmployeeJobService} from '../../../../app/services/cat-employee-job.service';
import {CreatorService} from '../../../../app/services/creator.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {forkJoin, of, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {ModalCatGoalEmployeeJobFisofoComponent} from '../../../shared/modal-cat-goal-employee-job-fisofo/modal-cat-goal-employee-job-fisofo.component';
import {CatGoalEmployeeJobFisofoService} from '../../../services/cat-goal-employee-job-fisofo.service';

@Component({
  selector: 'app-cat-goal-employee-fisofo',
  templateUrl: './cat-goal-employee-job-fisofo.component.html',
  styleUrls: ['./cat-goal-employee-job-fisofo.component.css']
})
export class CatGoalEmployeeJobFisofoComponent implements OnInit {

// estado pagina
  public page:string='CatGoalEmployeeJobFisofo';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public goals:ComGoalEmployeeJobModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  //
  constructor(
    private scGoalService:CatGoalEmployeeJobFisofoService,
    private catEmployeeJobService:CatEmployeeJobService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let goal=this.creator.newComGoalEmployeeJobModel();
    let modalRef=this.modalService.open(ModalCatGoalEmployeeJobFisofoComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.goal=goal;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.componentInstance.goals=this.goals;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(goal:ComGoalEmployeeJobModel)=> {
    console.log(">> Edit Goal: ", goal)
    let modalRef=this.modalService.open(ModalCatGoalEmployeeJobFisofoComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.goal={...goal};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.componentInstance.goals=this.goals;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.scGoalService.getAll(),
      this.scGoalService.getEmployeeJobs(),
    )
      .pipe(
        tap(([goalResp, empJobResp]:[any, any])=> {
          if(goalResp && empJobResp) {
            this.goals=goalResp.data;
            this.employeeJobCatalog=empJobResp.data;
            this.viewStatus=1;
            console.log(">> Goals: ", this.goals)
          }
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
        })
      )
      .subscribe();
  }

}
